import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./ProspectCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";
import { useAuth } from "../../contexts/AuthContext";

// Screens
import StudentInformations from "./StudentInformations";
import StudyInformations from "./StudyInformations";
import ContactInformations from "./ContactInformations";

// Services
import { createProspect } from "../../services/prospect.service";
import { showSuccess, showError } from "../../services/toast.service";

const ProspectCreate = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [prospectData, setProspectData] = useState({
    status: "Nouveau"
  });
  const [isMinor, setIsMinor] = useState(false);

  const handleProspectChange = (e) => {
    const { name, value } = e.target;
    setProspectData((prev) => ({ ...prev, [name]: value }));

    if (name === "birth_date") {
      if (value) {
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setIsMinor(age < 18);
      } else {
        setIsMinor(false);
      }
    }
  };

  const handleSwitchChange = (name, value) => {
    setProspectData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setProspectData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Ajouter automatiquement l'utilisateur connecté comme assigné
      const prospectDataWithAssignment = {
        ...prospectData,
        assigned_to: currentUser?.id
      };
      
      await createProspect(prospectDataWithAssignment);
      showSuccess("Prospect créé avec succès!");
      navigate("/admin/prospects_student/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer le prospect: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/prospects_student/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <StudentInformations
              prospect={prospectData}
              onProspectChange={handleProspectChange}
              onDropdownChange={handleDropdownChange}
            />
            <ContactInformations
              prospect={prospectData}
              onProspectChange={handleProspectChange}
              onDropdownChange={handleDropdownChange}
            />
            <StudyInformations
              prospect={prospectData}
              onProspectChange={handleProspectChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
              loading={loading}
            />
    
          </form>
        </div>
      </div>
    </>
  );
};

export default ProspectCreate;
